import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';

import {
  addOnboardingStepAfterGivenStepKey,
  emailCheck,
  hydrateOnboardingStorage,
  removeOnboardingStep,
  setCurrentOnboardingStep,
  setInitialOnboardingStep,
  setOnboardingFlow,
  setOnboardingFormValues,
} from 'src/app/state/actions';
import { SET_HORIZONTAL_PROGRESS_BAR_VISIBILITY } from 'src/app/state/actions/types';
import {
  getOnboardingCurrentIndex,
  getOnboardingIndexByStepKey,
  getOnboardingProgressFillPercent,
  getOnboardingSteps,
} from 'src/app/state/selectors';
import type { Dispatch, RootState } from 'src/app/state/store';
import { getLocationParams } from 'src/app/utils';

import type { FLOW } from './consts';
import { GetStarted } from './GetStarted';
import type { ProgressStep, STEP_NAME } from './StepLayout/consts';
import { STEP_KEY } from './StepLayout/consts';

const mapStateToProps = (state: RootState) => {
  return {
    onboardingSteps: getOnboardingSteps(state),
    onboardingForm: state.onboardingForm,
    currentStep: state.onboardingCurrentStep,
    progressBarFillPercent: getOnboardingProgressFillPercent(state),
    currentStepIndex: getOnboardingCurrentIndex(state),
    zipCodeParam: getLocationParams(state.router?.location?.search)?.['zipCode'],
    isDeliverableParam: getLocationParams(state.router?.location?.search)?.['isDeliverable'],
    stepFromQueryString: getLocationParams(state.router?.location?.search)?.['step']?.toUpperCase(),
    welcomeStepIndex: getOnboardingIndexByStepKey(state, STEP_KEY.WELCOME),
    checkZipCodeEligibility: state.client.checkZipCodeEligibility,
    isZipCodeDeliverable: state.onboardingForm.isZipCodeDeliverable,
    onboardingZipCode: state.onboardingForm.zipCode,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    onSetCurrentOnboardingStep: (step: STEP_NAME) => dispatch(setCurrentOnboardingStep(step)),
    onSetInitialOnboardingStep: (step: STEP_NAME) => dispatch(setInitialOnboardingStep(step)),
    onHydrateStoredFields: storedFields => dispatch(hydrateOnboardingStorage(storedFields)),
    onValidateEmail: (email: string) => dispatch(emailCheck(email)),
    onSetOnboardingFormValues: values => dispatch(setOnboardingFormValues(values)),
    setShowHorizontalProgressBar: isShown => dispatch({ type: SET_HORIZONTAL_PROGRESS_BAR_VISIBILITY, isShown }),
    dispatch,
    onSetOnboardingFlow: (flow: FLOW) => dispatch(setOnboardingFlow(flow)),
    onRemoveOnboardingStep: (step: STEP_KEY) => dispatch(removeOnboardingStep(step)),
    onAddStepAfterKey: (stepKey: STEP_KEY, progressStep: ProgressStep) =>
      dispatch(addOnboardingStepAfterGivenStepKey(stepKey, progressStep)),
  };
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type PropsFromRedux = ConnectedProps<typeof connector>;
export const GetStartedPage = connector(GetStarted);
